import { Skeleton } from '@/_components';

type FormFilesInputLoadingProps = {
  label?: string;
  className?: string;
  shape?: 'square' | 'circle' | 'rectangle';
  size?: 'md' | 'lg' | 'fluid';
};

export function FormFilesInputLoading({
  label,
  className,
  shape = 'rectangle',
  size = 'md',
}: FormFilesInputLoadingProps) {
  let dimensions = size === 'lg' ? 'size-24 md:size-28' : 'size-24';
  if (shape === 'rectangle') {
    dimensions = size === 'lg' ? 'h-24 w-[7.84rem] md:h-28 md:w-[9.49rem]' : 'h-24 w-[7.84rem]';
  }
  if (size === 'fluid') {
    dimensions = 'w-full h-36';
  }

  dimensions = `${dimensions} max-w-full`;

  return (
    <div className={className}>
      {label && (
        <div className="mb-2">
          <Skeleton className="h-5 w-1/4 rounded-md" />
        </div>
      )}
      <div className="xs:grid-cols-2 grid grid-cols-1 gap-4 sm:grid-cols-3 xl:grid-cols-4">
        {[1, 2, 3].map((key) => (
          <div key={key} className="flex h-full w-full flex-col items-center text-center">
            <Skeleton className={`${dimensions} rounded-xl`} />
            <Skeleton className="mt-1.5 h-4 w-3/4 rounded-md" />
          </div>
        ))}
      </div>
    </div>
  );
}
